/**
 * Serwis do zarządzania tokenami w localStorage i sessionStorage
 * 
 * Zapewnia trwałość sesji między odświeżeniami strony
 */
export const LocalStorageService = {
  /**
   * Zapisuje token w sessionStorage i localStorage
   */
  saveToken: (token: string): void => {
    sessionStorage.setItem('kc_token', token);
    // Zapisujemy też w localStorage dla większej trwałości
    localStorage.setItem('kc_token', token);
  },

  /**
   * Zapisuje refresh token w sessionStorage i localStorage
   */
  saveRefreshToken: (refreshToken: string): void => {
    sessionStorage.setItem('kc_refreshToken', refreshToken);
    // Zapisujemy też w localStorage dla większej trwałości
    localStorage.setItem('kc_refreshToken', refreshToken);
  },

  /**
   * Pobiera token z sessionStorage lub localStorage
   */
  getToken: (): string | null => {
    // Próbujemy najpierw pobrać z sessionStorage, a potem z localStorage
    return sessionStorage.getItem('kc_token') || localStorage.getItem('kc_token');
  },

  /**
   * Pobiera refresh token z sessionStorage lub localStorage
   */
  getRefreshToken: (): string | null => {
    // Próbujemy najpierw pobrać z sessionStorage, a potem z localStorage
    return sessionStorage.getItem('kc_refreshToken') || localStorage.getItem('kc_refreshToken');
  },

  /**
   * Usuwa tokeny z sessionStorage
   */
  clearTokens: (): void => {
    sessionStorage.removeItem('kc_token');
    sessionStorage.removeItem('kc_refreshToken');
    // Usuń też z localStorage jeśli tam są zapisane
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refreshToken');
  },

  /**
   * Sprawdza czy istnieje zapisany token w sessionStorage lub localStorage
   */
  hasToken: (): boolean => {
    return !!sessionStorage.getItem('kc_token') || !!localStorage.getItem('kc_token');
  }
};
